// src/features/business-functions/components/workspaces/WorkspaceCardGrid.jsx
import React from 'react';
import { Box, Grid, Skeleton } from '@mui/material';
import WorkspaceCard from './WorkspaceCard';

/**
 * 2-column responsive grid of workspace cards.
 * 1 column on mobile (xs), 2 columns on md+.
 */
export default function WorkspaceCardGrid({
  accountId,
  accountName,
  workspaces,
  canToggle = false,
  togglingWorkspaceId = '',
  onToggle,
  onMappingClick,
  canManageMappings,
  styles,
  isLoading,
}) {
  if (isLoading) {
    return (
      <Box sx={styles.workspaceCardGridRoot}>
        <Grid container spacing={2.5}>
          {[1, 2, 3, 4].map((i) => (
            <Grid item xs={12} md={6} key={i}>
              <Box sx={styles.skeletonCard}>
                <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center' }}>
                  <Skeleton variant="rounded" width={48} height={48} />
                  <Box sx={{ flex: 1 }}>
                    <Skeleton variant="text" width="70%" height={22} />
                    <Skeleton variant="text" width="90%" height={16} />
                  </Box>
                </Box>
                <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                  <Skeleton variant="text" width={80} height={14} />
                  <Skeleton variant="text" width={80} height={14} />
                  <Skeleton variant="text" width={100} height={14} />
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  }

  return (
    <Box sx={styles.workspaceCardGridRoot}>
      <Grid container spacing={2.5}>
        {workspaces.map((ws) => (
          <Grid item xs={12} md={6} key={ws.id}>
            <WorkspaceCard
              accountId={accountId}
              accountName={accountName}
              workspace={ws}
              canToggle={canToggle}
              isToggling={togglingWorkspaceId === ws.id}
              onToggle={onToggle}
              onMappingClick={onMappingClick}
              canManageMappings={canManageMappings?.(ws)}
              styles={styles}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
